export const AUTH_PORTAL_URLS = {
  LOGIN: '/auth/login',
  FORGOT_PASSWORD: '/auth/forgot-password',
};

export const PAGE_URLS = {
  LOGIN: '/login',
  LOGOUT: '/logout',
  FORGOT_PASSWORD: '/forgot-password',
  SSO_CALLBACK: '/sso/callback',

  HOME: '/',
  DASHBOARD: '/dashboard',
  NEW_DASHBOARD: '/loop/dashboard',
  STRIPE_ONBOARDING: '/stripe-onboarding',
  LEVEL_ONBOARDING: '/level-onboarding',

  SUBSCRIBER: '/subscriber',
  SUBSCRIBER_LIST: '/subscriber/list',
  SUBSCRIBER_CREATE: '/subscriber/create',
  SUBSCRIBER_INFO: '/subscriber/info',
  SUBSCRIBER_IMPORT: '/subscriber/import',

  EMPLOYER: '/employer',
  EMPLOYER_LIST: '/employer/list',
  EMPLOYER_CREATE: '/employer/create',

  EMPLOYEE: '/employee',
  EMPLOYEE_LIST: '/employee/list',
  EMPLOYEE_CREATE: '/employee/create',
  EMPLOYEE_INFO: '/employee/info',

  REVSHARE_INFO: '/revshare-info',
  REVSHARE_LIST: '/revshare-list',

  PARTNER_LIST: '/partner-plan', // TODO - Upadte it to /partner/list. Same applies for group, region, location
  CREATE_PARTNER: '/create-partner',
  PARTNER_INFO: '/partner-info',

  CREATE_GROUP: '/create-group',
  GROUP_LIST: '/group-list',
  GROUP_INFO: '/group-info',
  SETTINGS: '/settings',

  AFFILIATE_LIST: '/affiliates',
  CREATE_AFFILIATE: '/create-affiliate',
  AFFILIATE_INFO: '/affiliate-info',

  REGION_LIST: '/region-list',
  CREATE_REGION: '/create-region',
  REGION_INFO: '/region-info',

  LOCATION_LIST: '/location-list',
  CREATE_LOCATION: '/create-location',
  LOCATION_INFO: '/location-info',
  LOCATION_BULK_IMPORT: '/location-bulk-import',

  PLANS: '/plans',
  PLANS_LIST: '/plans/list',
  PLANS_CREATE: '/plans/create',
  PLANS_INFO: '/plans/info',
  PLANS_EDIT: '/plans/edit',

  USERS: '/users',
  USERS_LIST: '/users/list',
  USERS_CREATE: '/users/create',

  SUPPORT: '/support',
  MARKETING_MATERIALS: '/marketing-materials',
  TRANSFERS_PAYOUT: '/transfers-payout',
  CUSTOM_REPORTS: '/custom-reports',
  PROVIDER_PAYMENTS: '/provider-payments',
  ENROLLMENT_TRENDS: '/enrollment-trends',
  MORNING_HUDDLE: '/morning-huddle',

  SCHEDULE_TRAINING: '/schedule-training',
  FAQS: '/faqs',
  PLAN_MATERIALS: '/plan-materials',

  PATIENT_LOOKUP: '/patient-lookup',
  SAVINGS_CALCULATOR: '/savings-calculator',

  ADMIN: '/recur-admin',

  TERMS_OF_SERVICE: '/terms-of-service',
  HIPAA_NOTICE: '/hipaa-notice',
  PRIVACY_POLICY: '/privacy-policy',
  PATIENT_PRIVACY: '/patient-privacy',
  PATIENT_TERMS: '/patient-terms',

  FLEX_PACKAGE_DASBOARD: '/flex-package/dashboard',
  FLEX_PACKAGE_INVOICES: '/flex-package/invoices',
  FLEX_PACKAGE_INVOICES_LIST: '/flex-package/invoices/list',
  FLEX_PACKAGE_INVOICES_ORDER: '/flex-package/invoices/order',
  FLEX_PACKAGE_INVOICES_INFO: '/flex-package/invoices/info',

  FLEX_PACKAGE_PACKAGES: '/flex-package/packages',
  FLEX_PACKAGE_PACKAGES_LIST: '/flex-package/packages/list',
  FLEX_PACKAGE_PACKAGES_CREATE: '/flex-package/packages/create',
  FLEX_PACKAGE_PACKAGES_EDIT: '/flex-package/packages/edit',
  FLEX_PACKAGE_PACKAGES_INFO: '/flex-package/packages/info',

  PULSE_PAY: '/pulse-pay',
  PULSE_PAY_DASHBOARD: '/pulse-pay/dashboard',

  PULSE_PAY_INVOICES: '/pulse-pay/invoices',
  PULSE_PAY_INVOICES_LIST: '/pulse-pay/invoices/list',
  PULSE_PAY_INVOICES_MANAGE: '/pulse-pay/invoices/manage-invoice',
  PULSE_PAY_INVOICES_INFO: '/pulse-pay/invoices/info',
  PULSE_PAY_INVOICES_EDIT: '/pulse-pay/invoices/edit',
  PULSE_PAY_INVOICES_PAY: '/',
  PULSE_PAY_RETURN: '/pay-return',

  PULSE_PAY_PATIENTS_LIST: '/pulse-pay/patients/list',
  PULSE_PAY_PATIENTS_INFO: '/pulse-pay/patients/info',

  PULSE_PAY_TRANSACTIONS: '/pulse-pay/transactions',
  PULSE_PAY_TRANSACTIONS_PAYMENTS: '/pulse-pay/transactions/payments',
  PULSE_PAY_TRANSACTIONS_TRANSFERS: '/pulse-pay/transactions/transfers',

  PULSE_PAY_BATCH_INVOICES: '/pulse-pay/batch-invoices',

  SYNC: '/sync/',
};

export const PULSE_PAY_PATIENT_PAYMENT_DOMAINS = {
  local: 'pay.localhost.com',
  development: 'pay.dev.subscribili.com',
  qa: 'pay.qa.subscribili.com',
  staging: 'pay.staging.subscribili.com',
  production: 'pay.subscribili.com',
};

// Matches an optional region prefix before the env segment, e.g.
// pay.us.qa.subscribili.com, pay.eu.staging.subscribili.com
export const PULSE_PAY_PATIENT_PAYMENT_DOMAIN_PATTERN =
  /^pay\.(?:[a-z0-9-]+\.)?(?:localhost\.com|(?:dev|qa|staging)\.subscribili\.com|subscribili\.com)$/i;

// localStorage key for the invoice-scoped JWT minted by /api/v1/verify and used
// by the patient invoice-pay flow on PULSE_PAY_PATIENT_PAYMENT_DOMAINS. Kept
// separate from the provider-portal token keys (which are namespaced per
// region) because this flow is single-invoice and country-agnostic.
export const FLEX_PATIENT_ACCESS_TOKEN_KEY = 'flex_patient_access_token';

// Strapi API Endpoints (legal-page collection)
export const STRAPI_API_DISCLOSURE_STATEMENT_RECUR_EN =
  '/legal-pages?filters[slug][$eq]=terms-and-conditions-for-subscribers-of-group_name-plan&populate=*';
export const STRAPI_API_DISCLOSURE_STATEMENT_UK =
  '/legal-pages?filters[slug][$eq]=terms-and-conditions-uk&populate=*';
export const STRAPI_API_PRIVACY_POLICY_UK =
  '/legal-pages?filters[slug][$eq]=privacy-policy-uk&populate=*';
